import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
const AttendanceMonthlyPDF = () => {
    const empcode = localStorage.getItem('empcode');
    const { setLoading } = useLoading();
    const [data, setData] = useState([]);
    const [plants, setPlants] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [vendors, setVendors] = useState([]);

    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        DepartmentName: '',
        VenderName: '',
        EmployeeCode: '',
        EmployeeName: '',
        MonthYear: '',
        EmployeeStatus: '1',
        Mode:'pdf'
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [plantRes, companyRes, vendorRes] = await Promise.all([
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany('User'),
                EmployeeProcessService.getVender('User')
            ]);

            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompanies(companyRes.data.result);
            if (vendorRes?.data?.statusCode === 200) setVendors(vendorRes.data.result);

        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setFilters(prev => ({ ...prev, PlantName: plantId, DepartmentName: "" }));
        setDepartments([]);

        if (!plantId) return;

        try {
            const res = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (res?.data?.statusCode === 200) setDepartments(res.data.result);
        } catch (error) {
            console.error("Error loading departments:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const applyFilters = async () => {
        if (!filters.CompanyName || !filters.MonthYear) {
            alert("Please select Company and Month/Year.");
            return;
        }

        try {
            setLoading(true);
            const response = await EmployeeProcessService.getAttendanceMonthlyPDF(filters);
            if (response.data.statusCode === 200 && response.data.result.length > 0) {
                setData(response.data.result);
            } else {
                setLoading(false);
                setData([]);
                //toast.info("No records found");
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
            //toast.error("Failed to fetch data");
        }
    };

    const downloadPdfDirect = async () => {
        // if (!filters.CompanyName || !filters.PlantName || !filters.MonthYear) {
        //     alert("Please select Company, Plant, and Month/Year.");
        //     return;
        // }
        if (!filters.CompanyName || !filters.MonthYear) {
            alert("Please select Company and Month/Year.");
            return;
        }
        try {
            setLoading(true);

            // Get PDF blob from API
            const response = await EmployeeProcessService.getAttendanceMonthlyPDF(filters);

            if (response && response.data) {

            // ✅ Get content type from backend
            const contentType = response.headers["content-type"];

            // ✅ Detect file type
            let fileExtension = "pdf";
            if (contentType.includes("spreadsheetml")) {
                fileExtension = "xlsx";
            }

            // ✅ Create blob dynamically
            const blob = new Blob([response.data], { type: contentType });

            // ❌ NO FileReader needed (remove it)
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Attendance_${filters.MonthYear}.${fileExtension}`;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setLoading(false);
            alert(`✅ ${fileExtension.toUpperCase()} download initiated!`);

            } else {
                setLoading(false);
                alert("❌ No PDF received from server");
            }

        } catch (error) {
            setLoading(false);
            console.error("Error downloading PDF:", error);
            alert("Failed to download PDF");
        }
    };

    return (
        <div className="container mt-3">
            {/* Filters */}
            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="text-primary">Company</label>
                    <select className="form-select" name="CompanyName" value={filters.CompanyName} onChange={handleChange}>
                        <option value="">Select Company</option>
                        {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Plant</label>
                    <select className="form-select" name="PlantName" value={filters.PlantName} onChange={handlePlantChange}>
                        <option value="">Select Plant</option>
                        {plants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Department</label>
                    <select className="form-select" name="DepartmentName" value={filters.DepartmentName} onChange={handleChange}>
                        <option value="">Select Department</option>
                        {departments.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Vendor</label>
                    <select className="form-select" name="VenderName" value={filters.VenderName} onChange={handleChange}>
                        <option value="">Select Vendor</option>
                        {vendors.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                    </select>
                </div>

                <div className="col-md-3 mt-2">
                    <label className="text-primary">Employee Code Comma Separeted</label>
                    <input type="text" className="form-control" name="EmployeeCode" value={filters.EmployeeCode} onChange={handleChange} placeholder="Employee Code" />
                </div>

                <div className="col-md-3 mt-2">
                    <label className="text-primary">Employee Name</label>
                    <input type="text" className="form-control" name="EmployeeName" value={filters.EmployeeName} onChange={handleChange} placeholder="Employee Name" />
                </div>

                <div className="col-md-3 mt-2">
                    <label className="text-primary">Month / Year</label>
                    <input type="month" className="form-control" name="MonthYear" value={filters.MonthYear} onChange={handleChange} />
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Employee Status</label>
                    <select className="form-select" name="EmployeeStatus" value={filters.EmployeeStatus} onChange={handleChange}>
                        {/* <option value="">Employee Status</option> */}
                        <option value="1">Active</option>
                        <option value="0">In Active</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="text-primary">Download Mode</label>
                    <select className="form-select" name="Mode" value={filters.Mode} onChange={handleChange}>
                        {/* <option value="">Employee Status</option> */}
                        <option value="pdf">PDF</option>
                        <option value="excel">Excel</option>
                    </select>
                </div>
            </div>

            <div className="mb-3">
                <button className="btn btn-danger" onClick={downloadPdfDirect}>
                    Download PDF
                </button>
                {/* <button className="btn btn-primary me-2" onClick={applyFilters}>
                    Search
                </button>
                {data.length > 0 && (
                    <button className="btn btn-success" onClick={downloadPdfDirect}>
                        Download PDF
                    </button>
                )} */}
            </div>

        </div>
    );
};

export default AttendanceMonthlyPDF;
